export default {"src":"/_next/static/media/Cardiology.5416bd44.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};